import { ContentLoading } from '@/components/common/content-loading';
import { PATHS } from '@/router/paths';
import { useEffect } from 'react';
import { ErrorBoundary as ReactErrorBoundary } from 'react-error-boundary';
import { useLocation } from 'react-router-dom';

const ErrorFallback = () => {
    const location = useLocation();
    const isHomePage = location.pathname === PATHS.HOME.INDEX;

    useEffect(() => {
        if (isHomePage) {
            // eslint-disable-next-line no-console
            console.error('[ErrorBoundary] Error occurred on HomePage');
            return;
        }

        const timer = setTimeout(() => {
            window.location.replace(PATHS.HOME.INDEX);
        }, 800);

        return () => clearTimeout(timer);
    }, [isHomePage]);

    return <ContentLoading loading />;
};

export const ErrorBoundary = ({ children }: { children: React.ReactNode }) => {
    const location = useLocation();

    return (
        <ReactErrorBoundary
            FallbackComponent={ErrorFallback}
            resetKeys={[location.pathname]}
            onError={(error, info) => {
                // eslint-disable-next-line no-console
                console.error('[ErrorBoundary] ErrorBoundary caught:', error, info);
            }}
        >
            {children}
        </ReactErrorBoundary>
    );
};
